import { Color } from './Color';
/**
 * Color group make references to a set of small element (e.g SVG) sharing a same color
 */
export class ColorGroup {
    constructor(id, color = new Color()) {
        this.type = 'ColorGroup';
        this._id = id;
        this._color = color;
    }
    get color() {
        return new Color(this._color.hexaValue);
    }
    set color(color) {
        this._color = color;
    }
    get id() {
        return this._id;
    }
    static hydrate(data) {
        return new ColorGroup(data._id, new Color(data._color._hexaValue));
    }
}
